import { animation, availableAnimations } from "@global/global-animation";

class IconMenu {
    constructor() {
        this.state = {
            namespace: null,
            setNamespace: (stateObject, namespace) => {
                stateObject.namespace = namespace;
            }
        };

        this.actions = {
            resetStyle: (node) => {
                if (node.style) {
                    node.style.cssText = '';
                }

                if (node.childElementCount) {
                    for (let i = 0; i < node.children.length; i++) {
                        this.actions.resetStyle(node.children[i]);
                    }
                }
            }
        };

        this.options = {
            namespace: null,
            menuItems: [
                {
                    className: 'button-contact',
                    event: {
                        callback: e => {

                            const contactButton = e.target.closest(`.button-contact`);
                            contactButton.classList.toggle('open');
                        },
                        type: 'click'
                    }
                },
                {
                    className: 'quicksearch__trigger',
                    event: {
                        callback: e => {
                            e.target.closest('.quicksearch__trigger').classList.toggle('open');
                        },
                        type: 'click'
                    }
                },
                {
                    className: 'menu-button',
                    event: {
                        callback: (e) => {
                            const mainNavigation = e.currentTarget.nextElementSibling;
                            const button = e.currentTarget;

                            button.classList.toggle('open');

                            const overlay = document.querySelector('.overlay');

                            if (mainNavigation) {
                                if (button.classList.contains('open')) {
                                    overlay.classList.add('show');
                                    //button.querySelector(`${this.state.namespace}.button__extended-button`).style.height = '61px';
                                    mainNavigation.style.display = 'block';
                                    let mainNavigationHeight = mainNavigation.scrollHeight;
                                    mainNavigation.style.height = '0px';

                                    if(mainNavigation.childElementCount) {
                                        for (let i = 0; i < mainNavigation.childElementCount; i++) {
                                            mainNavigation.children[i].style.display = 'none';
                                        }
                                    }

                                    setTimeout(() => {
                                        mainNavigation.style.height = `${mainNavigationHeight}px`;
                                    },1);

                                    if(mainNavigation.childElementCount) {
                                        for (let i = 0; i < mainNavigation.childElementCount; i++) {
                                            setTimeout(() => {
                                                mainNavigation.children[i].style.cssText = '';
                                                animation.addAnimation(mainNavigation.children[i], availableAnimations.fades.fadeIn, null, [
                                                    {
                                                        eventType: 'animationend',
                                                        eventCallback: () => {
                                                            mainNavigation.style.height = '';
                                                            e.target.classList.remove(e.animationName);
                                                        }
                                                    }
                                                ])
                                            }, 500);
                                        }
                                    }
                                } else {
                                    if (overlay.classList.contains('show')) {
                                        overlay.classList.remove('show')
                                    }
                                    if(mainNavigation.childElementCount) {
                                        mainNavigation.style.height = `${mainNavigation.scrollHeight}px`;

                                        for (let i = 0; i < mainNavigation.childElementCount; i++) {
                                            mainNavigation.children[i].style.cssText = '';
                                            animation.addAnimation(mainNavigation.children[i], availableAnimations.fades.fadeOut, null, [
                                                {
                                                    eventType: 'animationstart',
                                                    eventCallback: (e) => {
                                                        e.target.classList.remove(e.animationName);
                                                    }
                                                },
                                                {
                                                    eventType: 'animationend',
                                                    eventCallback: (e) => {
                                                        e.target.classList.remove(e.animationName);
                                                    }
                                                }
                                            ]);
                                        }

                                        setTimeout(() => {
                                            mainNavigation.style.height = "0px";
                                        }, 500);

                                        setTimeout(() => {
                                            mainNavigation.style.cssText = ''
                                        }, 1000);
                                    } else {
                                        mainNavigation.style.height = "0px";

                                        setTimeout(() => {
                                            mainNavigation.style.cssText = ''
                                        }, 500);
                                    }

                                    //button.querySelector(`${this.state.namespace}.button__extended-button`).style.height = '40px';
                                    this.actions.resetStyle(document.querySelector(`${this.state.namespace}.navigation--medium`));
                                    document.querySelector(`${this.state.namespace}.main-navigation__slideout`).style.display = "none";
                                }
                            }
                        },
                        type: 'click'
                    },
                }
            ]
        };
    }

    init(overwriteOptions) {
        this.options = Object.assign(this.options, overwriteOptions);

        if (this.options.namespace) {
            this.state.setNamespace(this.state, `.${this.options.namespace} `);
        } else {
            this.state.setNamespace(this.state, '');
        }

        this.options.menuItems.forEach(menuItem => {
            const menuItemReferences = document.querySelectorAll(`${this.state.namespace}.${menuItem.className}`);
            menuItemReferences.forEach(menuItemReference => {
                menuItemReference.addEventListener(menuItem.event.type, menuItem.event.callback);
            });
        });
    }
}




export {IconMenu};
